export default __webpack_public_path__ + "static/media/uploader-dexcom-problem-2.08a9fb14.png";